import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FormInput from '../../components/FormInput';
import FormLabel from '../../components/FormLabel';
import SimpleButton from '../../components/SimpleButton';
import Spacer from '../../components/Spacer';
import { IApplicationState } from '../../store';
import { sweepRoomDraftUpdate, sweepsSaveRoomRequest } from '../../store/sweeps/slice';
import { ISweepRoom } from '../../store/sweeps/types';
import { Container } from './styles';

const RoomForm: React.FC = (props) => {
    const route = useMatch('/room/:idSweep/:idRoom/form');

    const routeRegister = useMatch('/room/:idSweep/form');

    const { t } = useTranslation();

    const idSweep = route?.params.idSweep || routeRegister?.params.idSweep;

    const idRoom = route?.params.idRoom;

    const sweep = useSelector((state: IApplicationState) => state.sweeps.data.find(sweep => sweep.id === idSweep))

    const room = sweep?.rooms.find(room => room.id === idRoom);

    const sweeps = useSelector((state: IApplicationState) => state.sweeps);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);

    const editingRoom = sweeps.draftRoom;

    const setEditingRoom = useCallback((room: ISweepRoom) => {
        dispatch(sweepRoomDraftUpdate(room))
    }, [dispatch])

    useEffect(() => {
        if (room && !isLoaded) {
            setIsLoaded(true)

            setEditingRoom({
                ...room,
                error: undefined
            })
        }
    }, [isLoaded, room, setEditingRoom])

    if (!editingRoom) {
        return <Container>
            <h1>{t("pages.rooms.not_found_form")}</h1>
        </Container>
    }

    return <Container>
        <h1>{room ? t("pages.rooms.edit_room") : t("pages.rooms.create_room")}</h1>

        <FormLabel>{t("pages.rooms.room_name")}</FormLabel>
        <FormInput
            value={editingRoom?.name || ""}
            onChangeText={(text) => {
                setEditingRoom({
                    ...editingRoom,
                    name: text
                })
            }}
        />

        <FormLabel>{t("pages.rooms.width")}</FormLabel>
        <FormInput
            value={String(editingRoom?.width || "") || ""}
            type={'currency'}
            onChangeText={(text) => {
                setEditingRoom({
                    ...editingRoom,
                    width: parseFloat(text.replace(',', '.') || "") || 0
                })
            }}
        />

        <FormLabel>{t("pages.rooms.length")}</FormLabel>
        <FormInput
            value={String(editingRoom?.length || "") || ""}
            type={'currency'}
            onChangeText={(text) => {
                setEditingRoom({
                    ...editingRoom,
                    length: parseFloat(text.replace(',', '.') || "") || 0
                })
            }}
        />

        <Spacer size={20} />

        <SimpleButton
            prependIcon='save'
            color='primary'
            disabled={editingRoom.isSaving}
            onClick={() => {
                dispatch(sweepsSaveRoomRequest(editingRoom))
            }}>
            {editingRoom.isSaving ? `${t("common.buttons.saving")}` : t("common.buttons.save")}
        </SimpleButton>

        <Spacer size={20} />

        {editingRoom.error !== undefined && <ErrorMessage>{editingRoom.error.message || t("common.undefined")}</ErrorMessage>}
    </Container>;
}

export default RoomForm;